module.exports = __webpack_public_path__ + "media/fonts/FiraSans-SemiBold-b6ffb4927db20d43cb135e2c4d1679f8.ttf";